module.exports = __webpack_public_path__ + "web_static/img/unmind_animation.c3d7eb9a.gif";